import { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';

import { formatNumber, sortTableDateFechaInicio, sortTableDateFechaFin, sortTableStatusStatus } from '../../utils/generalFunctions';

import { editarBreadcrumb } from '../../actions/breadcrumb';
import { buscarMembresias } from '../../actions/membresias';

const Membresias = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Membresías',
            path: '/membresias'
        }
    ];

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.membresias);

    const [membresias, setMembresias] = useState([]);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const handleRangoFechas = (inicio, fin) => {
        let diferencia = new Date(fin).getTime() - new Date(inicio).getTime();
        let total_dias = Math.ceil(diferencia / (1000 * 3600 * 24));

        if(total_dias <= 1){
            return 'Únicamente el ' + new Date(inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
        } else {
            return 'Del ' + new Date(inicio).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) +
                   ' al ' + new Date(fin).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' });
        }
    }

    const columns = [
        {
            name: 'Membresía',
            sortable: true,
            selector: row => row.membresia?.nombre || 'Sin definir'
        },
        {
            name: 'Total',
            sortable: true,
            selector: row => formatNumber(row.total, 2, '$ ', '')
        },
        {
            name: 'Método de pago',
            sortable: true,
            selector: row => {
                switch(row.metodo){
                    case 0: return 'Efectivo';
                    case 1: return 'Tarjeta';
                    case 2: return 'Transferencia';
                    default: return 'Sin definir';
                }
            }
        },
        {
            name: 'Periodo',
            sortable: true,
            sortFunction: sortTableDateFechaInicio,
            selector: row => handleRangoFechas(row.fecha_inicio, row.fecha_fin),
            grow: 3
        },
        {
            name: 'Status',
            sortable: true,
            sortFunction: sortTableStatusStatus,
            cell: row => {
                switch(row.status){
                    case 0:
                        return <h5><Badge pill bg="success">Activa</Badge></h5>;
                    case 1:
                        return <h5><Badge pill bg="warning" text="dark">Vencida</Badge></h5>;
                    case 2:
                        return <h5><Badge pill bg="danger">Cancelada</Badge></h5>;
                    default:
                        return null;
                }
            }
        }
    ];

    useEffect(() => {
        dispatch(buscarMembresias());
    }, []);

    useEffect(() => {
        setMembresias(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Historial de membresías</h3>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={membresias}
                            noDataComponent="No hay membresías registradas"
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Membresias;
